// extracted by mini-css-extract-plugin
export default {"wrapper":"UY2Yn"};